/**
 * Web console logging library for Call Panel.
 */

import debug from 'debug'

const Logger = {}

Logger.install = function (Vue) {
  Vue.mixin({
    mounted: function () {
      this.$options.__debugger = debug(`component:${this.$options.name}:`)
    },
    methods: {
      dbg: function (val) {
        this.$options.__debugger(val)
      }
    }
  })
}

export default Logger
